import { useEffect, useState } from "react";
import DesktopView from "./Views/DesktopView";
import MobileView from "./Views/MobileView";
import Credits from "./Components/CreditsDesktop";
import CreditsMobile from "./Components/CreditsMobile";
import MobileTabs from "./UI elements/MobileTabs";
import axiosInstance from "../../../../axiosInstance";
import { useSearchParams, useNavigate } from "react-router-dom";

const Profile = (props) => {
  const [searchParams, setSearchParams] = useSearchParams();
  const navigate = useNavigate();

  const [CreditsTabIsSelected, setCreditsTabIsSelected] = useState(false);
  const [ProfileInfo, setProfileInfo] = useState();

  useEffect(() => {
    fetchData();

    if (!searchParams.get("selectedTab")) {
      setSearchParams({ selectedTab: "profile" });
    }
  }, []);

  useEffect(() => {
    // Handles the temporary variable set to determine if the user clicked on
    // credits item in the nav menu of mobile devices
    if (window.localStorage.getItem("CreditsRequested") && ProfileInfo) {
      switchTabWithUrlUpdate(true);
      window.localStorage.removeItem("CreditsRequested");
    }
  }, [ProfileInfo]);

  useEffect(() => {
    const selectedTab = searchParams.get("selectedTab");

    if (selectedTab === "credit" && ProfileInfo) {
      setCreditsTabIsSelected(true);
    } else if (selectedTab === "profile" && ProfileInfo) {
      setCreditsTabIsSelected(false);
    }
  }, [searchParams, ProfileInfo]);

  const switchTabWithUrlUpdate = (isCreditsTab) => {
    setCreditsTabIsSelected(isCreditsTab);
    const selectedTab = isCreditsTab ? "credit" : "profile";

    navigate(`/Home/Profile?selectedTab=${selectedTab}`, {
      replace: true,
    });
  };

  const fetchData = () => {
    let Req = {
      method: "GET",
      baseURL: window.localStorage.getItem("BaseURL") + "/api/account",
      headers: {
        Authorization: "Bearer " + window.localStorage.getItem("Token"),
      },
    };
    axiosInstance(Req)
      .then((Res) => {
        setProfileInfo(Res.data);
      })
      .catch((Err) => {
        console.log(Err);
      });
  };

  return (
    <>
      {/* {ProfileInfo ? <ProfileHead ProfileInfo={ProfileInfo} /> : null} */}
      {props.isMobileOrTablet ? (
        <MobileTabs
          SwitchTab={switchTabWithUrlUpdate}
          CreditsTabIsSelected={CreditsTabIsSelected}
        />
      ) : null}
      <>
        {CreditsTabIsSelected ? (
          <>
            {props.isMobileOrTablet ? (
              <CreditsMobile
                SwitchTab={switchTabWithUrlUpdate}
                CreditsTabIsSelected={CreditsTabIsSelected}
                ProfileInfo={ProfileInfo}
              />
            ) : (
              <Credits
                SwitchTab={switchTabWithUrlUpdate}
                CreditsTabIsSelected={CreditsTabIsSelected}
                ProfileInfo={ProfileInfo}
              />
            )}
          </>
        ) : (
          <>
            {ProfileInfo ? (
              <>
                {props.isMobileOrTablet ? (
                  <>
                    <MobileView
                      CreditsTabIsSelected={CreditsTabIsSelected}
                      isMobileOrTablet={true}
                      SwitchTab={switchTabWithUrlUpdate}
                      ProfileInfo={ProfileInfo}
                      UpdateProfileInfo={() => fetchData()}
                    />
                  </>
                ) : (
                  <DesktopView
                    SwitchTab={switchTabWithUrlUpdate}
                    CreditsTabIsSelected={CreditsTabIsSelected}
                    ProfileInfo={ProfileInfo}
                    UpdateProfileInfo={() => fetchData()}
                  />
                )}
              </>
            ) : null}
          </>
        )}
      </>
    </>
  );
};

export default Profile;
